import { JSX, useEffect, useRef, useState } from "react";

import { Icon } from "components/icon/Icon";

import "./Expandable.scss";

interface ExpandableInput {
  header: JSX.Element
  footer?: JSX.Element
  minimizedMessage?: string
  expandIconText: string
  children: any[] | null
  className?: string
  startMinimized: boolean
  shrinkIconText?: string
}


export default function Expandable({
  header,
  footer,
  minimizedMessage,
  expandIconText,
  children,
  className = "",
  startMinimized = true,
  shrinkIconText = expandIconText
}: ExpandableInput) {
  const [expanded, setExpanded] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  const toggleExpanded = () => {
    console.log("Toggling expanded");
    setExpanded(!expanded);
    elementRef?.current?.scrollIntoView();
  };

  useEffect(() => {
    setExpanded(!startMinimized);
  }, [startMinimized]);

  return (
    <div ref={elementRef} className="expandable">
      <div className={`"expandableHeader" ${className}`}>
        {header}
        <div onClick={() => toggleExpanded()} className="expandableIcon">
          {!expanded && expandIconText}
          {expanded && shrinkIconText}
          <Icon
            size="lg"
            name={expanded ? "arrow-up" : "arrow-down"}
            className="ml-3"
          />
        </div>
      </div>
      {expanded && children}
      {expanded && footer && (
        <div className="expandableHeader">
          {footer}
          <div onClick={() => toggleExpanded()} className="expandableIcon">
            {!expanded && expandIconText}
            {expanded && shrinkIconText}
            <Icon
              size="lg"
              name={expanded ? "arrow-up" : "arrow-down"}
              className="ml-3"
            />
          </div>
        </div>
      )}
      {!expanded && minimizedMessage}
    </div>
  );
}